import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import { Group, TextInput, Button, Stack, PasswordInput, Alert, Box, Text } from '@mantine/core';
import { WarningRounded } from '@mui/icons-material';
import {set_profile_data, set_account_data, set_token, set_loader} from '../../../redux/action/General/generalActions';
import Logo from '../../../assests/svg/Logo.svg';
import EyeIcon from '../../../assests/svg/EyeIcon.svg';
import RedCross from '../../../assests/svg/RedCross.svg';
import { check_auth } from '../../../helpers/Uitls';
import { RolePermissionGet, SignInPost } from '../../../helpers/fetchApis/Auth';
import { AccountGet } from '../../../helpers/fetchApis/Accounts';
import { hideNotification, showNotification } from '@mantine/notifications';
import { UserGet } from '../../../helpers/fetchApis/Users';
import du from '../../../helpers/language/du';

class Login extends Component {

    challengeContainerRef = React.createRef();
    recaptchaWidgetRef = null;

    state={
        visible: false,
        password: '',
        email: '',
        requiresChallenge: false
    }
    
    constructor(props) {
        super(props);
        document.querySelector('meta[name="description"]').setAttribute("content", 'Im hellohousing Mieterportal finden Sie Ihre aktuellen Verbräuche, alle Dokumente und tauschen Nachrichten aus. Hier anmelden.');
        document.title= 'hellohousing Mieterportal - Anmeldung';
    }

    componentDidMount() {
        window.history.pushState({}, undefined, "/login");
    }

    handlePasswordChange=(e)=>{
        this.setState({password: e.currentTarget.value});
    }

    handleUsernameChange=(e)=>{
        this.setState({email: e.currentTarget.value});
    }

    handleSubmit = async (e, fallbackToken = null, isRecaptchaV2 = false) => {
        if (e) e.preventDefault();
        this.props.set_loader(true);

        let recaptchaToken = fallbackToken;
        
        if (!recaptchaToken) {
            try {
                await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
                recaptchaToken = await window.grecaptcha.enterprise.execute('6Lee-40sAAAAAH3KM7HK3E9rq13H69XWcptUYE2a', { action: 'login' });
            } catch (error) {
                console.error('Invisible reCAPTCHA failed:', error);
                this.props.set_loader(false);
                showNotification({
                    icon: <img src={RedCross} alt='red-cross'/>,
                    message: 'Sicherheitsüberprüfung fehlgeschlagen. Bitte laden Sie die Seite neu.'
                });
                return;
            }
        }

        SignInPost({
            email: this.state.email,
            password: this.state.password,
            recaptchaToken: recaptchaToken,
            isRecaptchaV2: isRecaptchaV2
        }, this.props.set_loader, res => {
            
            if (res && res.message === 'FORBIDDEN') {
                this.props.set_loader(false);
                this.setState({ requiresChallenge: true }, () => {
                    setTimeout(() => {
                        if (window.grecaptcha && this.challengeContainerRef.current) {
                            if (this.recaptchaWidgetRef !== null) {
                                window.grecaptcha.enterprise.reset(this.recaptchaWidgetRef);
                            } else {
                                this.recaptchaWidgetRef = window.grecaptcha.enterprise.render(this.challengeContainerRef.current, {
                                    sitekey: '6Ldi5rYsAAAAAPMy2dv_Rxe99-WiKfE_FosVcnQN', 
                                    callback: (solvedToken) => {
                                        this.handleSubmit(null, solvedToken, true);
                                    },
                                    'error-callback': () => {
                                        showNotification({
                                            icon: <img src={RedCross} alt='red-cross'/>,
                                            message: 'Es gab ein Problem mit dem Captcha.'
                                        });
                                    }
                                });
                            }
                        }
                    }, 100);
                });
                return;
            }

            this.setState({ requiresChallenge: false });
            this.recaptchaWidgetRef = null;

            if (res && res.token) {
                RolePermissionGet(res.token, res1 => {
                    if(res1){
                        this.props.set_token(res.token);
                        this.props.set_profile_data({id: res.id});
                        this.props.set_loader(false);
                        hideNotification('user-sigin');
                        AccountGet(res.accountId, accountRes => {
                            this.props.set_account_data(accountRes);
                            if(accountRes &&  accountRes.accountId){
                                UserGet(this.props.profile.id, profileRes=> {
                                    if(profileRes.isEmailVerified){
                                        this.props.set_profile_data({...this.props.profile, ...profileRes});
                                        let redirectUrl = localStorage.getItem('redirectUrl');
                                        window.history.pushState({}, undefined, redirectUrl && redirectUrl.length > 0 ? redirectUrl : "/dashboard");
                                    }else{
                                        this.props.set_account_data({});
                                        window.localStorage.setItem('signupEmail', profileRes.email);
                                        window.location.href='/emailVerification';
                                    }
                                });
                            }
                        });
                    }else{
                        showNotification({
                            message: <div dangerouslySetInnerHTML={{__html: du.general.text_general_error}}/>,
                            id: 'general_error',
                            icon: <img src={RedCross} alt='red-tick'/>,
                        });
                        this.props.set_loader(false);
                    }
                })
            }
        });
    }

    render() {
        const {visible, password, email, requiresChallenge} = this.state;
        return (
        <>
            <Stack className="login-view" id="respond-dashboard-page" style={{justifyContent: 'center', alignItems: 'center'}}>
                <img src={'./hello-housing-logo.svg'} alt='hello-housing' style={{marginBottom: '30px'}}/>
                <Stack className='card' spacing={10}>
                    <Group><span className='card-title'>Willkommen!</span></Group>
                    <Group>
                        <form onSubmit={this.handleSubmit}>
                            <Stack style={{width: requiresChallenge ? '376px' : '304px'}}>
                                <Group grow>
                                    <TextInput
                                        label="E-Mail Adresse"
                                        value={email}
                                        onChange={this.handleUsernameChange}
                                    />
                                </Group>
                                <Group grow>
                                    <PasswordInput
                                        label="Passwort"
                                        value={password}
                                        onChange={this.handlePasswordChange}
                                        visibilityToggleIcon={({ reveal, size }) =>
                                            reveal ? <img src={EyeIcon} size={size} alt="eye"/> : <img src={EyeIcon} size={size} alt="eye"/>
                                        }
                                    />
                                </Group>

                                {requiresChallenge && (
                                    <Alert color="yellow" title="Sicherheitsüberprüfung" icon={<WarningRounded />} sx={{ marginTop: 16, marginBottom: 16 }}>
                                        <Text size="sm" mb={10}>Bitte bestätigen Sie, dass Sie ein Mensch sind, um fortzufahren.</Text>
                                        <Box ref={this.challengeContainerRef} sx={{ display: 'flex', justifyContent: 'center' }}></Box>
                                    </Alert>
                                )}

                                {!requiresChallenge && (
                                    <Group style={{justifyContent: 'space-between'}}>
                                        <span className='forget-password' onClick={()=> {window.location.href='/forgotPassword'}}>Passwort vergessen?</span>
                                        <Button className='purple-btn btn-text' type="submit">Anmelden</Button>
                                    </Group>
                                )}
                            </Stack>
                        </form>
                    </Group>
                </Stack>
            </Stack>
        </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
      profile: state.generalReducer.profileData,
      isMobile: state.generalReducer.isMobile,
      isTablet: state.generalReducer.isTablet
    };
};

const actions = {
    set_profile_data,
    set_account_data,
    set_token,
    set_loader
};

export default connect(mapStateToProps, actions)(Login);